import { NavLink } from 'react-router-dom';
import { clsx } from 'clsx';
import { useAlerts } from '@/api/hooks';

interface MobileNavItem {
  label: string;
  to: string;
  icon: React.ReactNode;
  badge?: number;
}

function DashIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>;
}
function MapIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/><line x1="9" x2="9" y1="3" y2="18"/><line x1="15" x2="15" y1="6" y2="21"/></svg>;
}
function FieldsIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>;
}
function BellIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>;
}
function MoreIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>;
}

export function MobileNav() {
  const { data: alertsData } = useAlerts({ status: 'active' });
  const activeAlertCount = alertsData?.meta?.totalCount ?? 0;

  const navItems: MobileNavItem[] = [
    { label: 'Dashboard', to: '/app/dashboard', icon: <DashIcon /> },
    { label: 'Map', to: '/app/map', icon: <MapIcon /> },
    { label: 'Fields', to: '/app/fields', icon: <FieldsIcon /> },
    { label: 'Alerts', to: '/app/alerts', icon: <BellIcon />, badge: activeAlertCount > 0 ? activeAlertCount : undefined },
    { label: 'More', to: '/app/settings', icon: <MoreIcon /> },
  ];

  return (
    <nav
      className="flex items-stretch bg-white border-t border-gray-200 safe-area-inset-bottom"
      aria-label="Mobile navigation"
    >
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            clsx(
              'flex-1 flex flex-col items-center justify-center gap-1 py-2 text-xs font-medium transition-colors',
              isActive ? 'text-earth-700' : 'text-gray-500 hover:text-gray-700',
            )
          }
          aria-label={item.label}
        >
          {({ isActive }) => (
            <>
              <span className="relative">
                <span className={clsx(
                  'block transition-transform',
                  isActive && 'scale-110',
                )}>
                  {item.icon}
                </span>
                {item.badge != null && (
                  <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">
                    {item.badge > 9 ? '9+' : item.badge}
                  </span>
                )}
              </span>
              <span>{item.label}</span>
              {isActive && (
                <span className="absolute bottom-0 h-0.5 w-8 bg-earth-600 rounded-t-full" />
              )}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
